import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface SimpleGroupBuyFieldsProps {
  isGroupBuy: boolean;
  targetQuantity: number | null;
  endDate: string | null;
  lockedPrice: number | null;
  basePrice: number;
  measurementUnit: string;
  limitToTarget: boolean;
  onIsGroupBuyChange: (enabled: boolean) => void;
  onTargetQuantityChange: (value: number) => void;
  onEndDateChange: (value: string) => void;
  onLockedPriceChange: (value: number) => void;
  onLimitToTargetChange: (value: boolean) => void;
}

export const SimpleGroupBuyFields = ({
  isGroupBuy,
  targetQuantity,
  endDate,
  lockedPrice,
  basePrice,
  measurementUnit,
  limitToTarget,
  onIsGroupBuyChange,
  onTargetQuantityChange,
  onEndDateChange,
  onLockedPriceChange,
  onLimitToTargetChange,
}: SimpleGroupBuyFieldsProps) => {
  const formatUnit = (unit: string) => {
    const units: Record<string, string> = {
      'square_meter': 'מ"ר',
      'meter': 'מטר',
      'unit': 'יח\'',
      'cubic_meter': 'מ"ק',
      'kilogram': 'ק"ג',
      'liter': 'ליטר',
      'package_by_meter': 'מטר',
      'package_by_square_meter': 'מ"ר'
    };
    return units[unit] || unit;
  };

  return (
    <>
      {isGroupBuy && (
        <>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="target-quantity">יעד כמותי ({formatUnit(measurementUnit)})</Label>
              <Input
                id="target-quantity"
                type="number"
                min="1"
                step="0.01"
                value={targetQuantity || ""}
                onChange={(e) => onTargetQuantityChange(parseFloat(e.target.value))}
                placeholder={`לדוגמה: 500 ${formatUnit(measurementUnit)}`}
              />
              <p className="text-xs text-muted-foreground">
                הכמות הכוללת שצריך להגיע אליה
              </p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="end-date">תאריך סיום</Label>
              <Input
                id="end-date"
                type="datetime-local"
                value={endDate || ""}
                onChange={(e) => onEndDateChange(e.target.value)}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="locked-price">מחיר קבוע לקבוצת רכישה (₪)</Label>
            <Input
              id="locked-price"
              type="number"
              min="0"
              step="0.01"
              value={lockedPrice || ""}
              onChange={(e) => onLockedPriceChange(parseFloat(e.target.value))}
              placeholder={`מחיר רגיל: ₪${basePrice.toFixed(2)}`}
            />
            <p className="text-xs text-muted-foreground">
              אם ריק, יחויב המחיר הרגיל (₪{basePrice.toFixed(2)})
            </p>
          </div>

          <div className="flex items-center space-x-2 space-x-reverse">
            <input
              type="checkbox"
              id="limit-to-target"
              checked={limitToTarget}
              onChange={(e) => onLimitToTargetChange(e.target.checked)}
              className="h-4 w-4 rounded border-input"
            />
            <Label htmlFor="limit-to-target" className="text-sm font-normal cursor-pointer">
              הגבל רכישה ליעד הכמותי בלבד (לא ניתן להזמין מעבר ליעד)
            </Label>
          </div>
        </>
      )}
    </>
  );
};
